import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { IAppState } from './state';

export function localStorageSyncReducer(reducer: ActionReducer<IAppState>): ActionReducer<IAppState> {
  return localStorageSync({
    keys: ['core'],
    rehydrate: true,
    storageKeySerializer: () => 'core',
  })(reducer);
}

export const metaReducers: Array<MetaReducer<IAppState>> = [localStorageSyncReducer];
